import axiosAuth from '../axiosAuth'
import { getAccessToken } from '../utils/session/sessionToken.ts'
import { extractAccessTokenFromOAuthBody } from '../utils/session/oauthApiResponse.ts'

export const refreshOAuthAccessToken = async (): Promise<string> => {
  const token = getAccessToken()
  if (!token) {
    throw new Error('missing access token')
  }
  const response = await axiosAuth.request({
    method: 'POST',
    url: '/oauth/token/refresh',
    headers: { Authorization: `Bearer ${token}` },
  })
  const next = extractAccessTokenFromOAuthBody(response.data)
  if (!next) {
    throw new Error('invalid refresh response')
  }
  return next
}

export const notifyServerLogout = (token?: string | null): void => {
  const authToken = token ?? getAccessToken()
  if (!authToken) {
    return
  }
  void axiosAuth
    .post('/auth/oauth/access/logout', null, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
    .catch(() => {})
}
